import { GroupviewCacheItem, GroupviewModel } from "@/Models/Groupview";
import { TreeRenderElement } from "@/components/ObjectViews/TreeviewRenderer";
import { SectionPlane, SectionPlanesPlugin } from "@xeokit/xeokit-sdk";
import { TreeViewCacheItem, TreeviewModel } from "../../Models/Treeview";

export interface ViewerState {
    selectedEntities: string[];
    highlightedEntities: string[];
    invisibleEntities: string[];
    invisibleEntitiesHash: Set<string>;
    xrayedEntities: string[];
    scheduleIsolatedMeasure: boolean;
    isolatedMeasureInvisibles: string[];
    pickerIsEnabled: boolean;
    openPlugin: "" | "SectionPlanes" | "Measurer";
    sectionPlanesPlugin: SectionPlanesPlugin | null;
    sectionPlanes: SectionPlane[];
    projection: "perspective" | "ortho" | "frustum";
    treeViewCache: TreeViewCacheItem[];
    groupViewCache: GroupviewCacheItem[];
    gridEnabled: boolean;
    spaceEnabled: boolean;
    addingSectionPlane: boolean;
    invisibleAsXray: boolean;
    treeviewObjects: TreeviewModel[];
    groupViewObjects: GroupviewModel[][];
    treeviewRender: TreeRenderElement[];
    groupViewRender: TreeRenderElement[];
}

export const initialViewerState: ViewerState = {
    selectedEntities: [],
    highlightedEntities: [],
    invisibleEntities: [],
    xrayedEntities: [],
    scheduleIsolatedMeasure: false,
    isolatedMeasureInvisibles: [],
    pickerIsEnabled: true,
    openPlugin: "",
    sectionPlanesPlugin: null,
    sectionPlanes: [],
    projection: "perspective",
    treeViewCache: [],
    groupViewCache: [],
    gridEnabled: false,
    spaceEnabled: false,
    addingSectionPlane: false,
    invisibleAsXray: false,
    treeviewObjects: [],
    groupViewObjects: [],
    treeviewRender: [],
    groupViewRender: [],
    invisibleEntitiesHash: new Set<string>(),
};
